import { render, staticRenderFns } from "./ErrorOrderDetail.vue?vue&type=template&id=4d0e9566"
import script from "./ErrorOrderDetail.vue?vue&type=script&lang=js"
export * from "./ErrorOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./ErrorOrderDetail.vue?vue&type=style&index=0&id=4d0e9566&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports